/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_PreviousInputs */

const id_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelumnya`)
};

const ms_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum`)
};

const da_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const de_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige`)
};

const en_us2_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const es_es2_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const es_mx2_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fil_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraan`)
};

const fr_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précédent`)
};

const it_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedente`)
};

const hu_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző`)
};

const nl_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige`)
};

const no_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const pl_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednia`)
};

const pt_br2_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const pt_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const ro_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fi_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen`)
};

const sv_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående`)
};

const vi_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước`)
};

const tr_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki`)
};

const cs_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí`)
};

const bg_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишен`)
};

const ru_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const uk_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const ar_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السابق`)
};

const hi_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला`)
};

const th_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อนหน้า`)
};

const ja_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前へ`)
};

const zh_cn2_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const zh_hant1_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const ko_forms_review_previous = /** @type {(inputs: Forms_Review_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Forms_Review_PreviousInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_previous = /** @type {((inputs?: Forms_Review_PreviousInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_PreviousInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_previous(inputs)
	if (locale === "ms") return ms_forms_review_previous(inputs)
	if (locale === "da") return da_forms_review_previous(inputs)
	if (locale === "de") return de_forms_review_previous(inputs)
	if (locale === "en-US") return en_us2_forms_review_previous(inputs)
	if (locale === "es-ES") return es_es2_forms_review_previous(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_previous(inputs)
	if (locale === "fil") return fil_forms_review_previous(inputs)
	if (locale === "fr") return fr_forms_review_previous(inputs)
	if (locale === "it") return it_forms_review_previous(inputs)
	if (locale === "hu") return hu_forms_review_previous(inputs)
	if (locale === "nl") return nl_forms_review_previous(inputs)
	if (locale === "no") return no_forms_review_previous(inputs)
	if (locale === "pl") return pl_forms_review_previous(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_previous(inputs)
	if (locale === "pt") return pt_forms_review_previous(inputs)
	if (locale === "ro") return ro_forms_review_previous(inputs)
	if (locale === "fi") return fi_forms_review_previous(inputs)
	if (locale === "sv") return sv_forms_review_previous(inputs)
	if (locale === "vi") return vi_forms_review_previous(inputs)
	if (locale === "tr") return tr_forms_review_previous(inputs)
	if (locale === "cs") return cs_forms_review_previous(inputs)
	if (locale === "bg") return bg_forms_review_previous(inputs)
	if (locale === "ru") return ru_forms_review_previous(inputs)
	if (locale === "uk") return uk_forms_review_previous(inputs)
	if (locale === "ar") return ar_forms_review_previous(inputs)
	if (locale === "hi") return hi_forms_review_previous(inputs)
	if (locale === "th") return th_forms_review_previous(inputs)
	if (locale === "ja") return ja_forms_review_previous(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_previous(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_previous(inputs)
	return ko_forms_review_previous(inputs)
});
export { forms_review_previous as "forms.review.previous" }